import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { LangProvider } from "@/lib/i18n";
import { SiteProvider } from "@/lib/site";

function App() {
  return (
    <SiteProvider>
    <LangProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { borderRadius: 0, background: "#131311", border: "1px solid #2b2a27", color: "#ece8df" } }} />
    </BrowserRouter>
    </LangProvider>
    </SiteProvider>
  );
}

export default App;
